<template>
    <div class="header">
        <div class="header-left">
            <i class="mr10" :class="classNameFn()" />
            <span :title="defaultObj.label">{{ defaultObj.label }}</span>
        </div>
        <div class="header-right">
            <el-dropdown split-button :disabled="currentNodeType === 1"  @click="handleClick" @command="handleCommand">
                <span class="mr10">{{ value }}</span>
                <span><i style="font-size: 14px;" :class="iconArray[valueIndex].icon"></i></span>
                <!-- <i :class="iconArray[valueIndex].icon"></i> -->
                <el-dropdown-menu slot="dropdown" class="dropdownClass">
                    <div style="width:100%" v-for="item in optionBtns" :key="item.code">
                        <el-dropdown-item :command="item.code" v-if="item.isBool">
                            <i :class="item.icon"></i>
                            <!-- <span class="ml10">{{ item.name }}</span> -->
                            <span class="ml10">{{ $t(`integration.${item.content}`) }}</span>
                        </el-dropdown-item>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- 新增架构 -->
        <AddDialog :isShow.sync="isShow" :title="title" ref="AddDialog" :valueIndex="valueIndex" />
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
import { shareParam } from '@/api/modules/public.js';

import AddDialog from '../dialog/AddDialog.vue';

export default {
    components: {
        AddDialog
    },
    props: ['defaultTreeObj'],
    data() {
        return {
            value: $t('integration.add_to'),
            valueIndex: 0,
            iconArray: [
                { icon: 'iconfont icon-zuzhijiagou', type: '0' },
                { icon: 'el-icon-picture', type: '1' },
                { icon: 'iconfont icon-ditu', type: '2' }
            ],
            optionBtns: [],
            isShow: false,
            title: '',
            currentNodeType:0,
            defaultObj: {}
        };
    },
    mounted() {
        this.getDefaultTree();
        this.hasFn();
        this.getParamData();
        this.deleteBtns();
    },
    methods: {
        getDefaultTree() {
            this.defaultObj = { ...this.defaultTreeObj };
        },
        getParamData() {
            shareParam({ code: 'schema_type', type: 0 }).then(({ result }) => {
                this.optionBtns = result.map((item, index) => {
                    this.iconArray.forEach(opt => {
                        if (opt.type === item.code) {
                            item.icon = opt.icon;
                        }
                    });
                    // item.icon = this.iconArray[index];
                    this.$set(item, 'isBool', true);
                    return item;
                });
            });
        },
        hasFn() {
            // 客户节点情况下的默认值
            if (this.$store.state.type !== 3 && this.$store.state.type !== 2) {
                this.optionBtns.forEach((item, index) => {
                    if (index !== 0) {
                        item.isBool = false;
                    }
                });
            }
        },
        deleteBtns() {
            bus.$on('nodeClickTree', row => {
                console.log('row--点击--', row)
                console.log('row--点击-this.optionBtns-', this.optionBtns)
                // 如果是客户节点  则只需要组织节点
                this.defaultObj = row;
                this.classNameFn();
                this.valueIndex = 0;
                this.currentNodeType = row.funcType;
                if (row.level === 0) {
                    this.optionBtns.forEach((item, index) => {
                        item.isBool = true;
                    });
                } else {
                    this.optionBtns.forEach(item => {
                        item.isBool = true;
                    });
                }
                // 树节点功能类型，0-单元节点，1-平面图节点，2-地图节点
                // 如果选择的是单元节点且不为客户节点
                if (row.level !== 0 && row.funcType === 0) {
                    this.optionBtns.forEach(item => {
                        item.isBool = true;
                    });
                    this.valueIndex = 0;
                }
                // 如果选择的是平面图节点且不为客户节点
                else if (row.level !== 0 && row.funcType === 1) {
                    this.optionBtns.forEach((item, index) => {
                        // if (item.code === '1') {
                        //     item.isBool = true;
                        //     this.valueIndex = index;
                        // } else {
                        //     item.isBool = false;
                        // }
                      item.isBool = false;
                    });
                }
                // 如果选择的地图图节点且不为客户节点
                else if (row.level !== 0 && row.funcType === 2) {
                    this.optionBtns.forEach((item, index) => {
                        if (item.code === '2') {
                            item.isBool = false;
                        } else {
                            item.isBool = true;
                        }
                    });
                    this.valueIndex = 1;
                }
            });
        },
        isDialog() {
            this.isShow = true;
            // this.title = $t('integration.add') + `[${this.optionBtns[this.valueIndex].name}]` + $t('integration.architecture');
            this.title = $t('integration.add') + `[${$t(`integration.${this.optionBtns[this.valueIndex].content}`)}]` + $t('integration.architecture');
            this.$nextTick(() => {
                this.$refs['AddDialog'].clearValidate();
                this.$refs['AddDialog'].getSysCode();
            });
        },
        classNameFn() {
            if (this.defaultObj.level === 0) return 'iconfont icon-kehu';
            //nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图）
            else if (this.defaultObj.nodeType === 2) {
                switch (this.defaultObj.funcType) {
                    case 0: {
                        return 'iconfont icon-zuzhijiagou';
                    }
                    case 1: {
                        return 'el-icon-picture';
                    }
                    case 2: {
                        return 'iconfont icon-ditu';
                    }
                    default:
                        break;
                }
            }
        },
        handleClick(value) {
            console.log(value)
            this.isDialog();
        },
        handleCommand(value) {
            this.valueIndex = Number(value);
            this.isDialog();
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    height: 50px;
    width: 100%;
    border-bottom: 1px solid $borderColor3;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .header-left {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
    }

    .header-right {
        flex: 1;

        .el-dropdown {
            width: 100%;
        }

        ::v-deep .el-button-group > .el-button:first-child {
            width: 100px;
        }
    }

    .mr10 {
        margin-right: 10px;
        cursor: pointer;
    }
}

.ml10 {
    margin-left: 10px;
}
</style>
